var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-grm-comp": "RoomTestbankHistoryListTable" } },
    [
      _c("div", { staticClass: "h-full flex flex-col hidden lg:flex" }, [
        _c("table", [
          _vm._m(0),
          _c("thead", { staticClass: "h-8 bg-gray-200" }, [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("common.number")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("testBank.kind")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("setting.name.title")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("testBank.number.question")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("testBank.number.taker")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("testBank.period")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("testBank.limit")))]),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "max-h-full overflow-y-auto scrollbar-hide" },
          [
            _c("table", [
              _vm._m(1),
              _c(
                "tbody",
                [
                  [
                    _vm._l(
                      _vm.testbankExamHistoryList?.content,
                      function (exam, i) {
                        return _c(
                          "tr",
                          {
                            key: exam.roomExamId,
                            staticClass:
                              "cursor-pointer transition hover:bg-gray-100",
                            on: {
                              click: function ($event) {
                                return _vm.onSelectTestbankExamHistory(exam)
                              },
                            },
                          },
                          [
                            _c("td", [_vm._v(_vm._s(_vm.examNum(i)))]),
                            _c("td", [_vm._v(_vm._s(_vm.examType(exam)))]),
                            _c("td", [_vm._v(_vm._s(exam.examTitle))]),
                            _c("td", [
                              _vm._v(
                                _vm._s(exam.bankExam.questionList?.length)
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(exam.roomExamUserCnt))]),
                            _c("td", [
                              _vm._v(
                                _vm._s(exam.beginDate) +
                                  " ~ " +
                                  _vm._s(exam.endDate)
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(_vm.examDuration(exam)))]),
                          ]
                        )
                      }
                    ),
                    !_vm.testbankExamHistoryList?.content?.length
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { colspan: "7" },
                            },
                            [_vm._v(_vm._s(_vm.$t("testBank.noHistory")))]
                          ),
                        ])
                      : _vm._e(),
                  ],
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "flex flex-col gap-2 lg:hidden" },
        _vm._l(_vm.testbankExamHistoryList?.content, function (exam, i) {
          return _c(
            "div",
            { key: exam.roomExamId, staticClass: "p-2 rounded bg-gray-100" },
            [
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("common.number"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.examNum(i))),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("testBank.kind"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.examType(exam))),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("setting.name.title"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(exam.examTitle)),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("testBank.number.question"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(exam.bankExam.questionList?.length)),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("testBank.number.taker"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(exam.roomExamUserCnt)),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("testBank.period"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(exam.beginDate) + " ~ " + _vm._s(exam.endDate)),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("testBank.limit"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.examDuration(exam))),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "py-2 px-3 flex justify-center" },
                [
                  _c(
                    "GrmBtn",
                    {
                      staticClass: "flex-1",
                      attrs: { size: "sm" },
                      on: {
                        click: function ($event) {
                          return _vm.onSelectTestbankExamHistory(exam)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("setting.disclosure.password.see")))]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
      !_vm.testbankExamHistoryList?.content?.length
        ? _c("div", { staticClass: "lg:hidden" }, [
            _c(
              "p",
              { staticClass: "text-center p-2 rounded bg-gray-100 text-sm" },
              [_vm._v(_vm._s(_vm.$t("testBank.noHistory")))]
            ),
          ])
        : _vm._e(),
      _c("GrmPagination", {
        staticClass: "mt-3",
        attrs: { pageInfo: _vm.testbankExamHistoryList?.pageInfo },
        on: {
          paging: (page) => {
            _vm.getTestbankExamHistoryList({ page })
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "3%" } }),
      _c("col", { attrs: { width: "4%" } }),
      _c("col", { attrs: { width: "12%" } }),
      _c("col", { attrs: { width: "5%" } }),
      _c("col", { attrs: { width: "5%" } }),
      _c("col", { attrs: { width: "18%" } }),
      _c("col", { attrs: { width: "8%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "3%" } }),
      _c("col", { attrs: { width: "4%" } }),
      _c("col", { attrs: { width: "12%" } }),
      _c("col", { attrs: { width: "5%" } }),
      _c("col", { attrs: { width: "5%" } }),
      _c("col", { attrs: { width: "18%" } }),
      _c("col", { attrs: { width: "8%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }